import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { CMI5, LIBRARY, PARAMS, TABS_CONSTANTS } from '../../const';
import * as routeListener from '../../listeners/route/routeListener';

import * as messageAlert from '../../actions/messageAlertAction';
import * as libraryActions from '../../actions/libraryActions';
import { Catalog, ScrollToTop } from '@netexknowledge/smart-components';
import { getTokenFromStorage, LOCAL_STORAGE } from '../../shared';
import {
  API_ACTIVITIES_IMPORTED,
  API_BACKOFFICE_CUSTOMERS_BOOKS_METAS,
  API_BACKOFFICE_SCHOOL_BOOKS,
  API_BOOKS_LINKED,
  API_CMS_CUSTOMERS_ACTIVITIES_PREVIEW,
  API_CMS_CUSTOMERS_RESOURCES_PREVIEW,
  API_CMS_SEARCH,
  API_USERS_CLASSROOMS
} from '../../services/api/apiConst';
import { I18n } from 'react-redux-i18n-lite';
import axios from 'axios';
import { filterTabsByUserConfig } from '../../utils/tabsUtils';

import * as activityService from '../../services/domain/activityService';
import { ANALYTICS_CONTEXT } from '../../types/analytics';
import { trackCatalogAnalyticsEvent } from '../../services/api/analyticsApi';

class LibraryContainer extends React.Component {
  constructor(context, props) {
    super(context, props);
  }

  static propTypes = {
    routeParams: PropTypes.object,
    currentFilters: PropTypes.object,
    tags: PropTypes.array,
    isAppOnline: PropTypes.any,
    libraryActions: PropTypes.object,
    customerId: PropTypes.number,
    schoolId: PropTypes.number,
    userId: PropTypes.string,
    skinUrl: PropTypes.string,
    openSaltUrls: PropTypes.array,
    books: PropTypes.array,
    classrooms: PropTypes.array,
    locale: PropTypes.string,
    classroomTabs: PropTypes.array,
    showOnlyBookLibrary: PropTypes.bool,
    hideCatalogFilter: PropTypes.bool,
    role: PropTypes.string,
    catalogueSelectorTabs: PropTypes.array
  };

  getTabIndex() {
    const { classroomTabs, idClassroom } = this.props;
    if (idClassroom) {
      return classroomTabs.indexOf(TABS_CONSTANTS.CLASSROOM_LIBRARY) + 1 || 0;
    } else {
      return filterTabsByUserConfig(classroomTabs).indexOf(TABS_CONSTANTS.CLASSROOM_LIBRARY) + 1 || 0;
    }
  }

  getCatalogueSelectorTabs() {
    const { catalogueSelectorTabs } = this.props;

    const replaces = {
      BOOK: 'book',
      UNIT: 'unit',
      LESSON: 'lesson',
      ACTIVITY: 'activity',
      RESOURCE: 'file',
      ALL: 'all'
    };

    return catalogueSelectorTabs.map(tab => replaces[tab]);
  }

  isCreating = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = {};
    urlSearchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params['creating'] || 'none';
  };

  getActivityTypesFilterFields = () => {
    const { locale } = this.props;
    const fields = [];

    Object.keys(LIBRARY.ACTIVITY_TYPE).forEach(key => {
      const activityType = LIBRARY.ACTIVITY_TYPE[key];
      fields.push({
        label: I18n._getTranslations()[locale]['activityTypes'][activityType],
        value: activityType,
        icon: 'custom-icons-' + activityService.getActivityIcon(activityType)
      });
    });

    return fields;
  };

  getFileTypesFilterFields = () => {
    const { locale } = this.props;
    const fields = [];

    Object.keys(LIBRARY.FILE_TYPES).forEach(key => {
      const fileType = LIBRARY.FILE_TYPES[key];
      fields.push({
        label: I18n._getTranslations()[locale]['fileTypes'][fileType],
        value: fileType
      });
    });

    return fields;
  };

  getUnitActivityId = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = {};
    urlSearchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params['unitActivityId'];
  };

  getDisableImports() {
    if (this.isCreating() === 'lesson') {
      return {
        book: true,
        unit: true,
        lesson: false,
        activity: true,
        file: true
      };
    }

    if (this.isCreating() === 'unit') {
      return {
        book: true,
        unit: false,
        lesson: true,
        activity: true,
        file: true
      };
    }

    if (this.props.role !== 'INSTRUCTOR' && this.props.idClassroom) {
      return {
        book: true,
        unit: true,
        lesson: true,
        activity: true,
        file: true
      };
    }

    return {
      book: false,
      unit: true,
      lesson: true,
      activity: true,
      file: true
    };
  }

  getFixedResourceType() {
    if (this.isCreating() !== 'none') {
      return this.isCreating();
    }

    if (this.props.idClassroom) {
      return 'book';
    }

    return null;
  }

  getDefaultResourceType() {
    const catalogueSelectorTabs = this.getCatalogueSelectorTabs();
    if (catalogueSelectorTabs.length > 0) {
      return catalogueSelectorTabs[0];
    }
    return 'book';
  }

  getClassroomsImportedUrl() {
    let url = API_ACTIVITIES_IMPORTED.replace(PARAMS.ACTIVITY, ':id');
    const userIds = localStorage.getItem(LOCAL_STORAGE.LIS_USER_IDS);
    if (userIds) {
      const idsArray = userIds.split(',').map(id => id.trim()).filter(Boolean);
      if (idsArray.length) {
        url += `&${idsArray.map(id => `platformUserIds=${encodeURIComponent(id)}`).join('&')}`;
      }
    }
    return url;
  }

  render() {
    const {
      customerId,
      schoolId,
      selectorNames,
      userId,
      idClassroom,
      openSaltUrls,
      books,
      classrooms,
      locale,
      disableCompetencyFilters,
      skinUrl
    } = this.props;

    const catalogueSelectorTabs = this.getCatalogueSelectorTabs();

    return (
      <>
        <ScrollToTop contentQuerySelector="[class^=slide-height-][aria-hidden='false']"></ScrollToTop>
        <Catalog
          classroomId={idClassroom}
          onAnalyticsEvent={trackCatalogAnalyticsEvent(idClassroom)}
          language={locale}
          authToken={getTokenFromStorage()}
          classroomsUrl={`${API_USERS_CLASSROOMS.replace(PARAMS.USER, userId)}?state=active`}
          classroomsImportedUrl={this.getClassroomsImportedUrl()}
          classroomsLinkedUrl={API_BOOKS_LINKED.replace(PARAMS.ACTIVITY, ':id')}
          previewUrl={API_CMS_CUSTOMERS_ACTIVITIES_PREVIEW.replace(PARAMS.CUSTOMER, customerId)}
          filePreviewUrl={API_CMS_CUSTOMERS_RESOURCES_PREVIEW.replace(PARAMS.CUSTOMER, customerId)}
          bookDetailsUrl={API_BACKOFFICE_SCHOOL_BOOKS.replace(PARAMS.SCHOOL, schoolId).replace(PARAMS.BOOK, ':id')}
          skinUrl={skinUrl}
          clientMetadataUrl={API_BACKOFFICE_CUSTOMERS_BOOKS_METAS.replace(PARAMS.CUSTOMER, customerId)}
          competenciesUrls={openSaltUrls}
          availableResourceTypes={
            this.props.showOnlyBookLibrary
              ? ['book']
              : catalogueSelectorTabs
              ? catalogueSelectorTabs
              : ['all', 'book', 'unit', 'lesson', 'activity', 'file']
          }
          overrideOnBookImport={this.props.overrideOnBookImport ?? false}
          onImport={({ classroomIds, activityId, importFrom, linked, bookActivityId, clone }) => {
            const origin =
              importFrom &&
              importFrom !== 'catalog' &&
              importFrom !== 'undefined' &&
              importFrom !== idClassroom
                ? importFrom
                : undefined;
            const unlinked = origin ? !linked : true;

            if (this.isCreating() === 'lesson') {
              if (clone) {
                const unitActivityId = this.getUnitActivityId();
                const bookId = this.props.routeParams?.idBook;
                this.props.libraryActions.cloneLessonToClassroom(activityId, origin, idClassroom, bookId, unitActivityId, ANALYTICS_CONTEXT.LESSON_CLONE_POPUP_CATALOGUE);
              } else {
                const unitActivityId = this.getUnitActivityId();
                const bookId = this.props.routeParams?.idBook;
                this.props.libraryActions.importLessonsToUnitClassroom(
                  idClassroom,
                  bookId,
                  unitActivityId,
                  [activityId],
                  ANALYTICS_CONTEXT.LESSON_IMPORT,
                  origin,
                  unlinked
                );
              }
            } else if (this.isCreating() === 'unit') {
              const book = books.find(b => b.id === this.props.routeParams?.idBook);

              this.props.libraryActions.importUnitToClassroom(
                bookActivityId,
                idClassroom,
                activityId,
                book.id,
                origin,
                ANALYTICS_CONTEXT.UNIT_IMPORT,
                unlinked
              );
            } else {
              const classroomsToImport = classrooms.filter(c => classroomIds.includes(c.id));
              this.props.libraryActions.importLibraryBooksToClassrooms(
                classroomsToImport,
                activityId,
                !Boolean(origin),
                unlinked,
                origin,
                false
              );
            }
          }}
          selectorNames={selectorNames}
          fixedResourceType={this.getFixedResourceType()}
          translationsObject={I18n._getTranslations()[locale]?.catalog}
          disableCompetencyFilters={disableCompetencyFilters}
          stylesModals={{
            transform: this.isCreating() !== 'none' ? undefined : `translate(${this.getTabIndex() - 1}00%, 0px)`
          }}
          axios={axios}
          activityTypesFilterFields={this.getActivityTypesFilterFields()}
          fileTypesFilterFields={this.getFileTypesFilterFields()}
          searchUrl={API_CMS_SEARCH.replace(PARAMS.CUSTOMER, customerId)
            .replace(PARAMS.SCHOOL, schoolId)
            .replace(PARAMS.TYPE, ':type')}
          activityTypeBookId={CMI5.ACTIVITY_TYPE.COURSE}
          activityTypeUnitId={CMI5.ACTIVITY_TYPE.UNIT}
          activityTypeLessonId={CMI5.ACTIVITY_TYPE.LESSON}
          activityTypeDefaultId={CMI5.ACTIVITY_TYPE.DEFAULT}
          fileTypeId={CMI5.ACTIVITY_TYPE.RESOURCE}
          hideFilters={this.props.hideCatalogFilter}
          defaultShowFilters={this.props.catalogFiltersExpandedByDefault}
          disableImports={this.getDisableImports()}
          startClassMonth={this.props.startClassMonth}
          defaultResourceType={this.getDefaultResourceType()}
        />
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LibraryContainer);

function mapStateToProps(state) {
  return {
    currentFilters: state.library.currentFilters,
    tags: state.library.tags,
    idClassroom: state.router.params.idClassroom,
    isAppOnline: state.connection.status.online,
    primary: state.theme.colors.primary,
    customerId: state.account.configuration.customerId,
    schoolId: state.school.school.id,
    selectorNames: state.account.configuration.competencyConfiguration,
    disableCompetencyFilters: state.account.configuration.disableCompetencyFilters,
    hideCatalogFilter: state.account.configuration.hideCatalogFilter,
    catalogFiltersExpandedByDefault: state.account.configuration.catalogFiltersExpandedByDefault,
    userId: state.account.user._id,
    openSaltUrls: state.account.configuration.openSaltUrls,
    books: state.book.books,
    classrooms: state.classrooms.activeClassrooms,
    locale: state.account.user.language,
    classroomTabs: state.account.configuration.classroomTabs,
    showOnlyBookLibrary: state.account.configuration.showOnlyBookLibrary,
    skinUrl: state.theme.skinUrl,
    startClassMonth: state.account.configuration.startClassMonth,
    role: state.classrooms.selectedClassroom.classroom.role,
    catalogueSelectorTabs: state.account.configuration.catalogueSelectorTabs,
    overrideOnBookImport: state.account.configuration.overrideOnBookImport
  };
}

function mapDispatchToProps(dispatch) {
  return {
    messageAlert: bindActionCreators(messageAlert, dispatch),
    routeListener: bindActionCreators(routeListener, dispatch),
    libraryActions: bindActionCreators(libraryActions, dispatch)
  };
}
